import { Alert } from "reactstrap";

export default function NotEnoughPermissions({ container }) {
  return (
    <Alert color="danger">
      <p>You do not have enough permissions to access this page.</p>
    </Alert>
  );
}
